import {useState} from 'react'
import {ListGroup} from 'react-bootstrap'

function TreeNode({node, children, depth, selected, onSelect}) {
    const [expanded, setExpanded] = useState(true)
    const hasChildren = children.length > 0

    return <>
        <ListGroup.Item
            action
            active={selected === node.id}
            onClick={() => onSelect(node.id)}
            style={{paddingLeft: `${depth * 16 + 12}px`}}
            className="py-1 border-0"
        >
            {hasChildren &&
                <span
                    onClick={(e) => {e.stopPropagation(); setExpanded(!expanded)}}
                    className="me-1"
                    style={{cursor: 'pointer', userSelect: 'none'}}
                >
                    {expanded ? '▾' : '▸'}
                </span>
            }
            {node.label}
        </ListGroup.Item>
        {expanded && children}
    </>
}

export default function ResourceTree({nodes = [], onToggleSelectedNodes}) {
    const [selected, setSelected] = useState(null)

    function handleSelect(id) {
        const next = selected === id ? null : id
        setSelected(next)
        onToggleSelectedNodes(next ? [next] : [])
    }

    function renderNodes(parentId, depth) {
        return nodes
            .filter(n => n.parentId === parentId)
            .map(n => (
                <TreeNode key={n.id} node={n} depth={depth} selected={selected} onSelect={handleSelect}>
                    {renderNodes(n.id, depth + 1)}
                </TreeNode>
            ))
    }

    return <ListGroup>{renderNodes(null, 0)}</ListGroup>
}
